<div mat-dialog-title>Case Quantity Alert
  <div class="dialog-close-button">
      <a (click)="onClose()" id="close">
          <img src="/assets/images/close-popup.png">
      </a>
  </div>
</div>
<div mat-dialog-content cdkFocusInitial>
  <div>
      <p>Please order in the correct case quantity multiplier.</p>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button [mat-dialog-close]="true" id="btn-ok">OK</button>
</div>